export default function () {
  const packages = document.querySelector('.js-tab-cards');
  const scorecard = document.querySelector('.js-scorecard');
  const packagesItems = document.querySelectorAll('.js-tab-cards-item');
  const activeClass = 'tab-cards__item--active';

  if (!packages) {
    return;
  }

  [].forEach.call(packagesItems, (function (element, index) {
    element.addEventListener('click', function (e) {
      if (!scorecard && window.innerWidth >= 960) {
        return;
      }

      removeClass(packages, 'tab-cards__items--active-1');
      removeClass(packages, 'tab-cards__items--active-2');
      removeClass(packages, 'tab-cards__items--active-3');
      addClass(packages, 'tab-cards__items--active-' + (index + 1));

      if (hasClass(element, activeClass)) {
        return;
      }

      if (!hasClass(element, activeClass)) {
       e.preventDefault();
      }

      [].forEach.call(packagesItems, (function (element2) {
        removeClass(element2, activeClass);
      }));

      toggleClass(element, activeClass);
    });
  }));
};
